/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const JupyterNotebookRunningEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('JUPYTER_NOTEBOOK_RUNNING_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class JupyterNotebookRunningEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JupyterNotebookRunningEnabledSettingParser.decode(input).map(res => new JupyterNotebookRunningEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return JupyterNotebookRunningEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JupyterNotebookRunningEnabledSettingParser.encode(data);
    }
    static schema() {
        return JupyterNotebookRunningEnabledSettingParser.schema();
    }
}
